module.exports = __webpack_public_path__ + "static/media/2.87dc373b.jpg";